import '@styles/views/csc.less';
import AppBannerCSC from '@components/app/appBannerCSC';
//import AppAdvantage from '@components/app/appAdvantage';
import AppCivilStationConstru from '@components/app/appCivilStationConstru';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
import AppFooter from '@components/app/appFooter';

const CSC = () => {
  return (
    <div className={'introduce-page'}>
      <AppBannerCSC />
      <AppCivilStationConstru />
      {/* <AppAdvantage showDesc  style={{ marginTop: '30px' }}/> */}
      {/* <AppDisplayDesc /> */}
      <AppFooter />
    </div>
  );
};

export default CSC;
